import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import { FaExchangeAlt } from "react-icons/fa";

const ActualizaRespuesta = (props) => {
  const [postNombre, setPostNombre] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const postData = (e) => {
    e.preventDefault();
    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ActualizarRespuesta/" +
        props.id,
      data: {
        respuesta: postNombre,
      },
    })
      .then((response) => {
        console.log(response.data);
        alert("Actualizada");
        closeModal(); // Cerrar modal después de la actualización exitosa
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };

  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        <FaExchangeAlt />
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">My account</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">EVIDENCIA</h6>
                    {/* Description */}
                    <div className="pl-lg-4">
                      <FormGroup>
                        <Input
                          type="select"
                          className="form-control-alternative"
                          id="input-postal-code"
                          onChange={(e) => setPostNombre(e.target.value)}
                        >
                          <option value="">Seleccione una opción</option>
                          <option value="Cumple">Cumple</option>
                          <option value="No Cumple">No Cumple</option>
                          <option value="No Aplica">No Aplica</option>
                        </Input>
                      </FormGroup>
                      <button
                        className="btn btn-primary btn-lg"
                        color="primary"
                        onClick={postData}
                      >
                        Actualizar
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default ActualizaRespuesta;
